__turbopack_context__.v({
  "checkboxLabel": "ConsentModal-module__FmusaW__checkboxLabel",
  "closeBtn": "ConsentModal-module__FmusaW__closeBtn",
  "disclaimers": "ConsentModal-module__FmusaW__disclaimers",
  "intro": "ConsentModal-module__FmusaW__intro",
  "modalContent": "ConsentModal-module__FmusaW__modalContent",
  "root": "ConsentModal-module__FmusaW__root",
  "submit": "ConsentModal-module__FmusaW__submit",
});
